import React, { useState } from 'react';
import { Modal, Button, Flex, Input, Select, Form } from 'antd';
import type { SelectProps } from 'antd';
import { USER_ROLES } from '../constants';

interface AddUserToProjectModalProps {
    open: boolean;
    onClose: () => void;
    onAdd: (name: string, role: number) => Promise<void>;
}

const userRoleOptions: SelectProps['options'] = [
    { value: USER_ROLES.tester, label: 'Тестировщик' },
    { value: USER_ROLES.developer, label: 'Разработчик' },
    { value: USER_ROLES.maintainer, label: 'Сопровождающий' },
    { value: USER_ROLES.planner, label: 'Планировщик' },
];

const AddUserToProjectModal: React.FC<AddUserToProjectModalProps> = ({ open, onClose, onAdd }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values: { name: string; role: number }) => {
        setLoading(true);
        try {
            await onAdd(values.name.trim(), values.role);
            form.resetFields();
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Отправка приглашения"
            open={open}
            onCancel={onClose}
            footer={null}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{ role: 2 }}
            >
                <Form.Item
                    label="Имя пользователя в telegram"
                    name="name"
                    rules={[
                        { required: true, message: 'Обязательное поле' },
                        { max: 60, message: 'Имя пользователя не может превышать 60 символов' },
                        {
                            pattern: /^@[A-Za-z0-9_]+$/,
                            message: 'Неверное имя пользователя',
                        },
                    ]}
                >
                    <Input 
                        placeholder="@example_user" 
                        count={{
                            show: true,
                            max: 60,
                        }}
                    />
                </Form.Item>

                <Form.Item
                    label="Роль в проекте"
                    name="role"
                    rules={[{ required: true, message: 'Выберите роль в проекте' }]}
                    help="Сопровождающие имеют больше прав, чем остальные пользователи"
                >
                    <Select
                        options={userRoleOptions}
                        placeholder="Выберите роль в проекте"
                    />
                </Form.Item>

                <Form.Item>
                    <Flex gap="middle" justify="end">
                        <Button onClick={onClose}>
                            Отмена
                        </Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Создать
                        </Button>
                    </Flex>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddUserToProjectModal;
